import { Box, ButtonBase, Typography } from "@mui/material";
import { Icon } from "@iconify/react";

export interface FilterChipProps {
  label: string;
  active?: boolean;
  onClick: () => void;
}

function FilterChip({ label, active, onClick }: FilterChipProps) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 12px 8px 14px",
        borderRadius: "999px",
        color: active ? theme.palette.primary.contrastText : theme.palette.text.primary,
        bgcolor: active
          ? theme.palette.primary.main
          : theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.06)"
            : "rgba(0, 0, 0, 0.05)",
        border:
          !active && theme.palette.mode === "light"
            ? "1px solid rgba(0, 0, 0, 0.06)"
            : "none",
        transition: "background 0.15s",
        "&:active": { transform: "scale(0.97)" },
      })}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>{label}</Typography>
      <Icon
        icon="solar:alt-arrow-down-linear"
        width={14}
        height={14}
        color="currentColor"
      />
    </ButtonBase>
  );
}

interface HistoryFilterBarProps {
  dateLabel: string;
  typeLabel: string;
  statusLabel: string;
  dateActive: boolean;
  typeActive: boolean;
  statusActive: boolean;
  onDateClick: () => void;
  onTypeClick: () => void;
  onStatusClick: () => void;
}

export function HistoryFilterBar(props: HistoryFilterBarProps) {
  return (
    <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      <FilterChip
        label={props.dateLabel}
        active={props.dateActive}
        onClick={props.onDateClick}
      />
      <FilterChip
        label={props.typeLabel}
        active={props.typeActive}
        onClick={props.onTypeClick}
      />
      <FilterChip
        label={props.statusLabel}
        active={props.statusActive}
        onClick={props.onStatusClick}
      />
    </Box>
  );
}
